import * as React from 'react';
import * as VehiclesModule from 'Modules/VehiclesModule';
import {connect} from 'react-redux';
import {createSerachQuery} from 'Connectors/_main';
import {withTranslation} from 'react-i18next';
import {checkPageQuery, Cell, Filter} from 'HelperFunctions/Lists';
import * as Dictionary from 'Models/Dictionary';
import moment from 'moment';
import {InfinityReactTable, InfinityScrollParams} from "components/common/InfinityReactTable";
import * as UserModule from "Modules/UserModule";
import i18n from "Translations/_i18n";
import {RootState} from "Redux/Reducers/_RootReducer";
import * as ContractModule from "Modules/ContractModule";

type ConnectedDispatch = {
    getVehiclesList: (params?: URLSearchParams, filterQuery?: boolean) => void;
    setVehicleDetailsPage: (vehicle: VehiclesModule.Types.CarDto) => void;
    t?: Function;
    setCurrentContractVin: Function;
};

type ConnectedProps = {
    vehiclesList: Array<VehiclesModule.Types.CarDto>;
    activeVehicleDetails: VehiclesModule.Types.CarDto;
    vehiclesListTotalCount: number,
    selectedContractVin: string,
};

type State = {
    activeSorting: string;
    activeFilters: Array<{ id: string, value: any }>;
};

class VehiclesListFull extends React.Component<ConnectedProps & ConnectedDispatch, State> {
    constructor(props: ConnectedProps & ConnectedDispatch) {
        super(props);
        this.state = {
            activeSorting: '',
            activeFilters: []
        };
        this.getFilteredData = this.getFilteredData.bind(this);
        this.getVehiclesListFull = this.getVehiclesListFull.bind(this);

        this.infinityScrollParams = new InfinityScrollParams();
        this.infinityScrollParams.setWaypointRef(React.createRef());

        this.setActiveSorting = this.setActiveSorting.bind(this);
    }

    private statusActiveFilter = Filter.TooltipFilter.bind(this, this.props.t('activeStatus'));
    private deviceIdFilter = Filter.InputTextFilter.bind(this, this.props.t('terminalId'), true);
    private vinFilter = Filter.InputTextWithDefaultValue.bind(this, this.props.t('VIN'), this.props.selectedContractVin || '');
    private modelFilter = Filter.InputTextFilter.bind(this, this.props.t('model'), true);
    private msisdnFilter = Filter.InputTextFilter.bind(this, this.props.t('MSISDN'), true);
    private vehicleSpeedSorting = Filter.speedSorting.bind(this, this.props.t('speedGps'));
    private lastFrameSorting = Filter.SortFilter.bind(this, this.props.t('latestDataframeDateTime'));
    private infinityScrollParams: InfinityScrollParams;

    private setActiveSorting(e: any, colId: string, onChange: Function) {
        this.setState({
                activeSorting: colId
            }, () => onChange(e)
        );
    }

    private async getFilteredData(filters: Array<{ id: any; value: any }>, filterQuery: boolean = true) {
        // filter query zawsze jak jest wykonywany request inny niż doładowanie porcji danych poprzez infinity scroll
        const params = createSerachQuery(filters);
        await this.props.getVehiclesList(params, filterQuery);
    }

    private async getVehiclesListFull(state: any, scrollLoad: boolean = false, firstLoadCount: number = null) {
        if (scrollLoad && this.props.vehiclesList.length >= this.props.vehiclesListTotalCount) {
            return 0;
        }

        const {activeFilters, currentPage, itemsPerLoad, itemsFirstLoad} = this.infinityScrollParams.prepareLoadParams(state, scrollLoad);

        // Jeśli w wywołaniu metody będzie przekazana wartość tzn. że dynamicznie była liczona ilość wierszy do pierwszego ładowania.
        // Wykonane ze względu na potrzebę sterowania tym w sytuacji np.
        const newItemsFirstLoad = firstLoadCount || itemsFirstLoad;
        this.infinityScrollParams.setLoading(true);

        //***** Naprawa błędnego filtrowania razem z sortowaniem
        Filter.FilterSortingFix.call(this, activeFilters);
        //******

        // żeby nie wysłać przypadkiem jakiegoś pustego filtra tylko jak ma jakieś value przypisane
        const activeFiltersPrepared = activeFilters.filter(element => element.value);

        // jeśli jest zaznaczona umowa w tabeli umów to filtruje po vinie pojazdu z tamtej umowy
        if (this.props.selectedContractVin) {
            activeFiltersPrepared.push({id: 'vin', value: this.props.selectedContractVin});
            this.props.setCurrentContractVin(null);
        }

        const query = checkPageQuery(
            activeFiltersPrepared,
            currentPage,
            itemsPerLoad,
            newItemsFirstLoad
        );

        // negacja dlatego bo scrollLoad nie jest filterQuery
        this.getFilteredData(query, !scrollLoad);

        this.infinityScrollParams.setLoading(false);

        this.setState({
            activeFilters: activeFiltersPrepared,
        });
    }

    public render() {
        const {vehiclesList, t, vehiclesListTotalCount} = this.props;
        const {activeVehicleDetails} = this.props;
        return (
            <>
                <div className="table__content" ref={this.infinityScrollParams.getWaypointRef()}
                     data-testid="vehicles-table-management">
                    <InfinityReactTable
                        data={vehiclesList}
                        columns={this.renderColumns(t)}
                        onFetchData={this.getVehiclesListFull}
                        getTrProps={(state, rowInfo, column) => {
                            let className = '';
                            if (rowInfo && rowInfo.original && activeVehicleDetails) {
                                className = rowInfo.original.id === activeVehicleDetails.id ? 'active' : '';
                            }
                            return {
                                className,
                                onClick: () => {
                                    this.props.setVehicleDetailsPage(rowInfo.original);
                                }
                            };
                        }}

                        waypointRef={this.infinityScrollParams.getWaypointRef()}
                    />
                </div>

                <div className="table__footer">
                    <div>
                        {vehiclesList.length} z {vehiclesListTotalCount}
                    </div>
                    {this.infinityScrollParams.getIsLoading() && <div className="table__footer-loader"/>}
                </div>
            </>
        );
    }

    private optionList = [
        {
            value: VehiclesModule.EnumTypes.CarActiveStatus.ACTIVE,
            label: i18n.t(`dictionary:${VehiclesModule.EnumTypes.CarActiveStatus.ACTIVE}`),
            number: 1,
            img: Dictionary.UserStatusIcon.get(UserModule.UserEnumTypes.Status.ACTIVE)
        },
        {
            value: VehiclesModule.EnumTypes.CarActiveStatus.TURNED_OFF,
            label: i18n.t(`dictionary:${VehiclesModule.EnumTypes.CarActiveStatus.TURNED_OFF}`),
            number: 1,
            img: Dictionary.UserStatusIcon.get(UserModule.UserEnumTypes.Status.BLOCKED)
        },
        {
            value: VehiclesModule.EnumTypes.CarActiveStatus.NO_ACTIVITY,
            label: i18n.t(`dictionary:${VehiclesModule.EnumTypes.CarActiveStatus.NO_ACTIVITY}`),
            number: 1,
            img: Dictionary.UserStatusIcon.get(UserModule.UserEnumTypes.Status.NOT_ACTIVE)
        }
    ];

    private renderColumns(t) {
        return [
            {
                Header: 'hiddenHeader',
                id: 'car_activity_status',
                className: 'cell cell__car-status',
                accessor: (value) => value,
                width: 122,
                Filter: this.statusActiveFilter,
                Cell: ({value}) => (
                    <>
                        {value.latestDataframe !== null ?
                            <div className="pv-5">
                                {value.idle && <span className="cell__exclamation-mark">
                                        &#9888;
                                    </span>}
                                <img
                                    className={Dictionary.CarStatusTableFilters.get(value.latestDataframe?.speedLimitExceedance) ? 'cell__car-img' : ''}
                                    src={Dictionary.CarStatusTableFilters.get(value.latestDataframe?.speedLimitExceedance)}
                                    height={25} alt=""/>
                                {value.idle ?
                                    <div className="text-center">
                                        <div className="font-bold">
                                            {t('noActivity')}:
                                        </div>
                                        {moment(value.latestDataframe?.dateTime).format('YYYY-MM-DD')}
                                    </div> : ''
                                }
                            </div>
                            : ''
                        }
                        {
                            value.turnOffDate ?
                                <div className="text-center">
                                    <div className="font-bold">
                                        {t('turnOffWhen')}:
                                    </div>
                                    {value.turnOffDate}
                                </div> : ''
                        }
                    </>
                )
            },
            {
                Header: 'hiddenHeader',
                id: 'deviceId',
                className: 'cell',
                accessor: 'deviceId',
                Filter: this.deviceIdFilter,
                Cell: Cell.CutTextCell,
            },
            {
                Header: 'hiddenHeader',
                id: 'vin',
                className: 'cell',
                accessor: 'vin',
                Filter: this.vinFilter,
                Cell: Cell.CutTextCell,
            },
            {
                Header: 'hiddenHeader',
                id: 'model',
                className: 'cell',
                accessor: 'model',
                Filter: this.modelFilter,
                Cell: Cell.CutTextCell
            },
            {
                Header: 'hiddenHeader',
                id: 'msisdn',
                className: 'cell',
                accessor: 'msisdn',
                Filter: this.msisdnFilter,
                Cell: Cell.CutTextCell
            },
            {
                Header: 'hiddenHeader',
                id: 'vehicleSpeed',
                className: 'cell cell--align-right',
                accessor: row => row.latestDataframe ? row.latestDataframe.speedGps : null,
                Cell: ({value}) => <>{value !== null ? `${value} km/h` : ''}</>,
                width: 80,
                Filter: this.vehicleSpeedSorting
            },
            {
                Header: 'hiddenHeader',
                id: 'satellite',
                className: 'cell',
                maxWidth: 60,
                accessor: 'latestDataframe.satellite',
                Filter: () => <div className="filter__title">{t('satellite')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'gsmSignal',
                className: 'cell',
                maxWidth: 80,
                accessor: 'latestDataframe.gsmSignal',
                Cell: ({value}) => <>{typeof value !== 'undefined' && value !== null ? `${Math.ceil(value)}%` : ''}</>,
                Filter: () => <div className="filter__title">{t('gsmSignal')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'mileageGps',
                className: 'cell cell--align-right',
                maxWidth: 90,
                accessor: 'latestDataframe.mileageGps',
                Cell: ({value}) => <>{typeof value !== 'undefined' && value !== null ? `${value} km` : ''}</>,
                Filter: () => <div className="filter__title">{t('mileageGps')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'acceleration',
                className: 'cell',
                accessor: 'latestDataframe.acceleration',
                maxWidth: 90,
                Filter: () => <div className="filter__title">{t('acceleration')}</div>,
                Cell: ({value}) => <span>{value ? `${value.toFixed(2)} g` : ''}</span>
            },
            {
                Header: 'hiddenHeader',
                id: 'latestDataframe',
                className: 'cell',
                accessor: 'latestDataframe.dateTime',
                width: 140,
                Filter: this.lastFrameSorting,
                Cell: ({value}) => typeof value !== 'undefined' && value !== null ? moment(value).format('HH:mm:ss, DD.MM.YYYY') : ''
            }
        ];
    }
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        getVehiclesList: (params?: URLSearchParams, filterQuery?: boolean) => dispatch(VehiclesModule.Actions.getCarsFiltered(params, false, filterQuery)),
        setVehicleDetailsPage: (vehicle: VehiclesModule.Types.CarDto) => dispatch(VehiclesModule.Actions.setActiveVehicle(vehicle)),
        setCurrentContractVin: (currentVin) => dispatch(ContractModule.Actions.setCurrentContractVin(currentVin)),
    };
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        vehiclesList: state.vehiclesStore.vehiclesListFiltered.results,
        activeVehicleDetails: state.vehiclesStore.activeVehicleDetails,
        vehiclesListTotalCount: state.vehiclesStore.vehiclesListFiltered.totalCount,
        selectedContractVin: state.contractStore.currentVin
    };
}

export default withTranslation(['carDetails', 'tables', 'forms'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(VehiclesListFull) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/CarsManagement/VehiclesListFull.tsx